import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="bg-gray-100 px-2 sm:px-6 py-6">
      {/* ================= CARD ================= */}
      <div className="bg-white p-4 sm:p-6 rounded-xl shadow-lg">
        <h1 className="text-2xl sm:text-3xl font-semibold text-blue-700 mb-4 text-center sm:text-left">
          Policy Knowledge Dashboard
        </h1>
<div className="overflow-x-auto border rounded-lg">
          <table className="min-w-[1400px] w-full text-sm border-collapse">
            <thead className="bg-gray-100 sticky top-0 z-10"> 
            <tr>
              <th className="border p-2">S.No.</th>
              <th className="border p-2">Policy</th>
              <th className="border p-2">Zones</th>
              <th className="border p-2">Project Zones/ Applicabilicy component</th>
              <th className="border p-2">Applied Charges</th>
              <th className="border p-2">Waived Off Charges</th>
              <th className="border p-2">Eligibility Criteria</th>
              <th className="border p-2">FAR</th>
              <th className="border p-2">Project Size</th>
              <th className="border p-2">Mandatory Facilities</th>
              <th className="border p-2">Density</th>
            </tr>
          </thead>

          <tbody>
            {/* ===== ROW 1 ===== */}
          <tr>
            <td className="border p-2 text-center" >1</td>
            <td className="border p-2 font-semibold" >
              Retirement Housing Policy
            </td>
            <td className="border p-2 text-center" >All</td>
            <td className="border p-2" >
              Residential Zones
            </td>

            <td className="border p-2" >
              EDC Rates are prescribed for residential group housing colony
              for 1.75 FAR shall be made applicable
              <br/><br/>
              IDC generally charged on Residential group housing basis.
              <br/><br/>
              Licence fees, Scrutiny fee, conversion charges
            </td>

            <td className="border p-2 text-center" >NA</td>

            <td className="border p-2">
              “Allottee” means a person/senior citizen, who acquires an
              apartment within the premises of a Retirement Housing Project
              exclusively for the residential purpose of an eligible resident.
              <br /><br />
              “Eligible Resident” means a senior citizen who is an
              Allottee/Resident of a Retirement Housing Project and who is
              55+ years of age.
              <br /><br />
              The eligible resident of Retirement Housing Project may not be
              the Allottee.
              <br /><br />

            </td>

            <td className="border p-2 text-center">
              Maximum 2.25
            </td>

            <td className="border p-2">
              Minimum 0.5 Acres,
              <br/>
              Maximum 10 Acres
            </td>

            <td className="border p-2">
              Medical Room (Min 100 Sq Mtr),
              <br />
              24×7 Ambulance & tie up with the nearest hospital.
              <br /><br />
              3 persons per dwelling unit & in case of
              (dormitory/hostel) 1 person per bed.
              <br /><br />
              Common dining/Mess,
              <br />
              Gym / Indoor games,
              <br />
              Power Backup, Barrier-free design,
              <br />
              Security, Housekeeping.
            </td>

            <td className="border p-2 text-center">
              250 to 900 PPA
            </td>
          </tr>



          {/* ===== Affordable Housing Policy ===== */}
          {/* ================= MAIN ROW ================= */}
          <tr>
            <td className="border p-2 text-center" rowSpan={3}>2</td>
            <td className="border p-2 font-semibold" rowSpan={3}>
              Affordable Housing Policy
            </td>
            <td className="border p-2 text-center" rowSpan={3}>All</td>
            <td className="border p-2" rowSpan={3}>
              Residential Zones
            </td>

            {/* Applied Charges */}
            <td className="border p-2" rowSpan={3}>
              EDC charged on plotted colony rates, Conversion
            </td>

            {/* Waived Off */}
            <td className="border p-2 text-center">
              IDC
            </td>

            {/* Eligibility */}
            <td className="border p-2" rowSpan={3}>
              Any person can apply.
              <br />
              First preference given to those who do not own a house in
              Haryana, Delhi, or Chandigarh.
              <br />
              Only one flat per family & cannot get another affordable flat
              anywhere in Haryana.
              <br /><br />
              After exhaustion of at least 25 Acres, the applicant can apply
              for a minimum of 2 acres.
              <br /><br />
              Up to 5% flats to the developer’s employees/relatives
              (same rates & rules)
            </td>

            <td className="border p-2 text-center" rowSpan={3}>
              2.25
            </td>

            <td className="border p-2" rowSpan={3}>
              Min 4 Acres, Max 30 Acres
            </td>

            <td className="border p-2" rowSpan={3}>
              Carpet area 20 Sq.m – 60 Sq.m
              <br/>
              Community hall (2000 Sq ft),
              <br />
              Anganwadi-cum-creche (2000 Sq ft),
              <br />
              Free maintenance for 5 years,
              <br />
              Parking (0.5 ECS per flat),
              <br />
              Internal roads & services.
            </td>

            <td className="border p-2 text-center" rowSpan={3}>
              850 – 900 PPA
            </td>
          </tr>

          {/* ================= ROW 2 ================= */}
          <tr>
            <td className="border p-2 text-center">
              Last EDC instalment waived off
              <br />
              if completed within 3.5 years
            </td>
           
          </tr>

          {/* ================= ROW 3 ================= */}
          <tr>
            <td className="border p-2 text-center">
              Licence fee
            </td>
          </tr>

{/* DDJAY Policy */}
           <tr>
  {/* S.No */}
  <td className="border p-2 text-center" rowSpan={3}>3</td>

  {/* Policy */}
  <td className="border p-2 font-semibold text-center" rowSpan={3}>
    Deen Dayal Jan Awas Yojna
  </td>

  {/* Zones */}
  <td className="border p-2 text-center">
    Low Potential Zone
  </td>

  {/* Project Zones */}
  <td className="border p-2 text-center" rowSpan={2}>
    All
  </td>

  {/* Applied Charges */}
  <td className="border p-2">
    EDC at 25%, license – 10,000, scrutiny
  </td>

  {/* Waived Off */}
  <td className="border p-2 text-center">
    Conversion & IDC
  </td>

  {/* Eligibility */}
  <td className="border p-2" rowSpan={3}>
    Colonizer / Developer / Landowner can apply.  
    <br /><br />
    Project must be completed in 7 years.  
    <br /><br />
    Must apply under Haryana Development & Regulation of Urban Areas Act, 1975
    / HUDRA Rules, 1975.  
    <br /><br />
    Areas covered under approved development plans.
    <br /><br />
    High Potential Zone only if DDJAY is specifically permitted.  
    <br /><br />
    Land must be designated for Residential / Residential Plotted /
    DDJAY use in Development Plan.  
    <br /><br />
    Project must be developed on a contiguous land parcel.  
    <br /><br />
    Same area norms apply in High Potential Zones.  
    <br /><br />
    CLU, if required, must be obtained as per rules.
  </td>

  {/* FAR */}
  <td className="border p-2 text-center" rowSpan={3}>
    Max 2.0
  </td>

  {/* Project Size */}
  <td className="border p-2 text-center" rowSpan={3}>
    Minimum 5 Acres  
    <br />
    Maximum 15 Acres
  </td>

  {/* Mandatory Facilities */}
  <td className="border p-2" rowSpan={3}>
    If sector &lt; 50 Acres, only one project up to 15 acres allowed.  
    <br /><br />
    Max 30% of residential sector area
    (includes group housing).  
    <br /><br />
    TOD zones (along MRTS corridors),
    restricted areas where residential plotted colonies
    are prohibited by the Development Plan.
  </td>

  {/* Density */}
  <td className="border p-2 text-center" rowSpan={3}>
    240 – 400 PPA
  </td>
</tr>

{/* ===== ROW 2 ===== */}
<tr>
  <td className="border p-2 text-center">
    Medium Potential Zone
  </td>

  <td className="border p-2">
    EDC at 50%, license – 1,00,000, scrutiny
  </td>

  <td className="border p-2 text-center">
    Conversion & IDC
  </td>
</tr>

{/* ===== ROW 3 ===== */}
<tr>
  <td className="border p-2 text-center">
    High Potential Zone
  </td>
  <td className="border p-2">
    Exclude Faridabad- Ballabgarh
  </td>
  <td className="border p-2">
    All charges covered at 75% of respective rates
    for residential plotted colony
  </td>

  <td className="border p-2 text-center">
    NA
  </td>
</tr>


<tr>
  {/* S.No */}
  <td className="border p-2 text-center" rowSpan={2}>4</td>

  {/* Policy */}
  <td className="border p-2 font-semibold text-center" rowSpan={2}>
    Transit Oriented Development (TOD)
  </td>

  {/* Zones */}
  <td className="border p-2 text-center" rowSpan={2}>
    All
  </td>

  {/* Project Zones */}
  <td className="border p-2 text-center">
    Intense TOD Zone
    <br />
    (within 500 M)
  </td>

  {/* Applied Charges */}
  <td className="border p-2" rowSpan={2}>
    All Charges in proportionate FAR
    <br /><br />
    IAC charges →
    <br />
    Residential – 2000
    <br />
    Commercial – 3000
    <br />
    Institutional / IT / ITeS – 500
  </td>

  {/* Waived Off Charges */}
  <td className="border p-2 text-center" rowSpan={2}>
    NA
  </td>

  {/* Eligibility */}
  <td className="border p-2" rowSpan={2}>
    High-Density Mixed-Use Land.  
    <br /><br />
    TOD can also apply along transit corridors
    where station spacing is ~1 km,
    effectively creating a continuous influence area.
    <br /><br />
    Projects must be located within TOD Zone,
    defined around MRTS (Mass Rapid Transit System) corridors.
    <br /><br />
    Projects already licensed may apply to avail
    additional FAR under TOD policy beyond FAR limits.
    <br /><br />
    TOD licences originally granted are for a
    defined validity period as per policy conditions.
    <br /><br />
    Projects Eligible:
    Group Housing, Commercial, Mixed Land Use
    (Residential + Commercial),
    IT / ITeS Projects & NILP Projects.
  </td>

  {/* FAR */}
  <td className="border p-2 text-center">
    GH – 3.5
    <br />
    Comm – 3.5
    <br />
    Institutional / IT / ITeS – 3.5
  </td>

  {/* Project Size */}
  <td className="border p-2 text-center" rowSpan={2}>
    NA
  </td>

  {/* Mandatory Facilities / Project Type */}
  <td className="border p-2" rowSpan={2}>
    Project Type:
    <br /><br />
    Mixed Land use →
    70% Residential + 30% Commercial
    <br /><br />
    Group Housing:
    Commercial up to 30%
    <br /><br />
    Commercial Projects:
    Residential up to 30%
  </td>

  {/* Density */}
  <td className="border p-2 text-center" rowSpan={2}>
    NA
  </td>
</tr>

{/* ===== ROW 2 ===== */}
<tr>
  {/* Project Zones */}
  <td className="border p-2 text-center">
    Transition TOD Zone
    <br />
    (Between 500 to 800 M)
  </td>

  {/* FAR */}
  <td className="border p-2 text-center">
    GH – 2.5
    <br />
    Comm – 2.5
    <br />
    Institutional / IT / ITeS – 3.0
  </td>
</tr>


{/* Industrial Licensing Policy*/}
<tr>
  {/* S.No */}
  <td className="border p-2 text-center">5</td>

  {/* Policy */}
  <td className="border p-2 font-semibold text-center">
    Industrial Licensing Policy
  </td>

  {/* Zones */}
  <td className="border p-2 text-center">
    All
  </td>

  {/* Project Zones */}
  <td className="border p-2 text-center">
    Agriculture Zone
  </td>

  {/* Applied Charges */}
  <td className="border p-2">
    All charges for different component
  </td>

  {/* Waived / Special Charges */}
  <td className="border p-2 text-center">
    50% EDC Industrial component
    <br />
    falling in urbanisable zone
    <br />
    near 500 m
  </td>

  {/* Eligibility Criteria */}
  <td className="border p-2">
    Any Colonizer / Developer / HSIIDC /
    Project Proponent applying for an
    industrial colony licence.
    <br /><br />
    Eligible zones:
    Industrial zone in the final development plan,
    Agriculture zone (outside urbanisable area)
    allowed only if notified.
    <br /><br />
    Thrust / Focus / Rural / Functional Clusters.
    <br /><br />
    Urbanisable zone allowed if sector plan conforms.
  </td>

  {/* FAR */}
  <td className="border p-2 text-center">
    Affordable Industrial Housing –
    <br />
    175 / 225
  </td>

  {/* Project Size */}
  <td className="border p-2">
    Hyper / High Potential Zone:
    Minimum 50 Acres
    <br /><br />
    Medium Potential Zone:
    Minimum 25 Acres
    <br /><br />
    Low Potential Zone:
    Minimum 15 Acres
    <br /><br />
    Affordable Industrial Housing:
    <br />
    90 Sq.m for LIG
    <br />
    60 Sq.m for EWS
  </td>

  {/* Mandatory Facilities */}
  <td className="border p-2">
    Roads, utilities, open spaces
    minimum 35%.
    <br /><br />
    Saleable area 65% max.
    <br /><br />
    Industrial use 35% – 45%
    (depends on size).
    <br /><br />
    Mixed use (Resi + Comm)
    20% – 30% max.
    <br /><br />
    In the AIH residential component,
    75% must be AIH.
    <br /><br />
    Low income group of affordable housing.
    <br /><br />
    EWS 40% of affordable housing.
  </td>

  {/* Density */}
  <td className="border p-2 text-center">
    600 – 900
  </td>
</tr>


{/* Eco friendly 
(Eco friendly housing ) */}
<tr>
  {/* S.No */}
  <td className="border p-2 text-center">6</td>

  {/* Policy */}
  <td className="border p-2 font-semibold text-center">
    Eco Friendly
    <br />
    (Eco friendly housing)
  </td>

  {/* Zones */}
  <td className="border p-2 text-center">
    NA
  </td>

  {/* Project Zones */}
  <td className="border p-2 text-center">
    Residential zone only
    <br />
    for eco-friendly housing
  </td>

  {/* Applied Charges */}
  <td className="border p-2 text-center">
    For Eco-friendly
    <br />
    security Fee
    <br />
    conversion charges
  </td>

  {/* Waived Off Charges */}
  <td className="border p-2 text-center">
    NA
  </td>

  {/* Eligibility Criteria */}
  <td className="border p-2 text-center">
    Residential zone only
  </td>

  {/* FAR */}
  <td className="border p-2 text-center">
    Eco-friendly Housing (CLU)
    <br />
    2000 Sqm. – 1 acre
    <br />
    ground coverage
    <br />
    20% & FAR 0.20
  </td>

  {/* Project Size */}
  <td className="border p-2 text-center">
    Plot size
    <br />
    2000 sqm to 2.5 acres
  </td>

  {/* Mandatory Facilities */}
  <td className="border p-2 text-center">
    Height Maximum 15 m
  </td>

  {/* Density */}
  <td className="border p-2 text-center">
    Only 1 dwelling unit
    <br />
    per plot for
    <br />
    Eco friendly housing
  </td>
</tr>

{/* NILP */}
<tr>
  {/* S.No */}
  <td className="border p-2 text-center">7</td>

  {/* Policy */}
  <td className="border p-2 font-semibold text-center">
    New Integrated Licensing Policy (NILP)
  </td>

  {/* Zones */}
  <td className="border p-2 text-center">
    All
  </td>

  {/* Project Zones */}
  <td className="border p-2 text-center">
    Group Housing
    <br />
    Plots
    <br />
    Affordable housing
    <br />
    Commercial
  </td>

  {/* Applied Charges */}
  <td className="border p-2 text-center">
    All charges on residential component
    shall be taken @ 5/7th % rate of
    group housing colony and
    <br /><br />
    For other Components All charges applicable on based on
    different components rates
  </td>

  {/* Waived Off Charges */}
  <td className="border p-2 text-center">
    NA
  </td>

  {/* Eligibility Criteria */}
  <td className="border p-2 text-center">
    Land must fall in a residential zone of an approval plan
    <br />
    Land should be beyond the 20% group housing limit of the sector
    <br /><br />
    <strong>Affordable Housing Obligation:</strong>
    <br />
    The colonizer must choose one of the following:
    <br /><br />
    Surrender 10% land to the government for affordable group housing,
    <br />
    Pay money instead of land at 3 times the collector rate.
    <br /><br />
    After this, the colonizer is exempt from providing EWS / NPN plots.
  </td>

  {/* FAR */}
  <td className="border p-2 text-center">
    Commercial FAR 1.75
    <br /><br />
    Residential :
    <br />
    Maximum Base FAR 1.25
    <br />
    Additional FAR 0.25 FAR (PDR)
  </td>

  {/* Project Size */}
  <td className="border p-2 text-center">
    Minimum Contiguous Land
    <br />
    10 Acres (Hyper / High Potential Towns)
    <br />
    5 Acres (Medium / Low Potential Towns)
  </td>

  {/* Mandatory Facilities */}
  <td className="border p-2 text-center">
    Up to 25 acres 10% land transferred to Govt.
    <br />
    Plots 2.5 sq.m/person
    <br />
    Project completion 7 years (5 + 2)
  </td>

  {/* Density */}
  <td className="border p-2 text-center">
    Maximum Density
    <br />
    400 PPA
  </td>
</tr>



          </tbody>
        </table>
      </div>
      </div>
    

      {/* ================= CALCULATOR LINK ================= */}
      <div className="max-w-xl mx-auto mt-6 text-center">
        <Link
          to="/cal"
          className="block w-full bg-green-600 text-white py-3 px-3 rounded-lg text-base sm:text-lg hover:bg-blue-700 transition"
        >
          Go to Calculator →
        </Link>
      </div>

    </div>
  );
}


